import { useContext } from 'react';

import {
  ConversationRowContext,
  ConversationRowContextValue,
} from './conversationRowContext';

export const useConversationRow = (): ConversationRowContextValue => {
  return useContext(ConversationRowContext);
};
